import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import { SearchBox } from 'ui/components';
import PaginationOptions from 'utils/domain/PaginationOptions';
import SortingOptions from 'utils/domain/SortingOptions';
import { getMessagesForLocale, FormattedMessage } from 'ui/i18n';

import './Search.scss';

@inject('SearchState', 'AppState')
@observer
export default class Search extends Component {
	static propTypes = {
		SearchState: PropTypes.object.isRequired,
		AppState: PropTypes.object.isRequired,
		leftSide: PropTypes.bool,
		iconButton: PropTypes.bool,
	};

	static defaultProps = {
		leftSide: false,
		iconButton: false,
	};

	@observable isQueryValid = true;
	@observable query = '';
	@observable focused = false;

	SearchState = this.props.SearchState;
	leftSide = this.props.leftSide;
	iconButton = this.props.iconButton;

	validateQuery(query) {
		const re = /^([0-9a-zA-Z-]{1,30})$/;
		return re.test(query);
	}

	@action
	search(query) {
		this.SearchState.search({
			query,
			sorting: new SortingOptions('itemName', 'asc'),
			pagination: new PaginationOptions(),
		});
	}

	@action
	onQueryChange(query, isValid) {
		this.query = query;
		this.isQueryValid = isValid;
	}

	@action
	setFocus(focused) {
		this.focused = focused;

		if (!focused) {
			this.isQueryValid = true;
		}
	}

	redirectOnSearch() {
		return this.SearchState.search.state.loading
			? <Redirect to={{ pathname: '/search', state: { query: this.query } }} />
			: null;
	}

	render() {
		const { search } = this.SearchState;
		const { locale } = this.props.AppState;
		const errorClass = locale === 'fr-CA' ? 'errorFR' : 'errorEN';
		return (
			<div
				className={`SidebarSearch ${this.leftSide ? 'leftSide tooltip' : ''}`}
			>
				{this.redirectOnSearch()}

				{this.focused &&
					!this.isQueryValid &&
					<div className={`SidebarSearch__Error ${errorClass}`}>
						{this.leftSide
							? <div className="toolTipBottom __Error">
									<FormattedMessage id="itemSearch.invalidNumber" />
									<i />
								</div>
							: <FormattedMessage id="itemSearch.invalidNumber" />}
					</div>}

				<SearchBox
					onSearch={this.search.bind(this)}
					validate={this.validateQuery.bind(this)}
					onChange={this.onQueryChange.bind(this)}
					disabled={search.state.loading}
					resetOnSearch={true}
					iconButton={this.iconButton}
					placeholder={
						getMessagesForLocale(locale)['itemSearch.placeholderText']
					}
					setFocus={this.setFocus.bind(this)}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Search/index.js